import React from 'react';
import '../../styles/admin/production/VisitStatusBadge.css';

const VisitStatusBadge = ({ status }) => {
  const statusConfig = {
    to_schedule: { label: 'À planifier', className: 'visit-status-to-schedule' },
    scheduled: { label: 'Planifiée', className: 'visit-status-scheduled' },
    in_progress: { label: 'En cours', className: 'visit-status-in-progress' },
    completed: { label: 'Terminée', className: 'visit-status-completed' },
    rescheduled: { label: 'Replanifiée', className: 'visit-status-rescheduled' },
    cancelled: { label: 'Annulée', className: 'visit-status-cancelled' }
  };

  const config = statusConfig[status] || { label: status, className: 'visit-status-default' };

  return (
    <span className={`visit-status-badge ${config.className}`}>
      {config.label}
    </span>
  );
};

export default VisitStatusBadge;